import { AxiosError } from 'axios';
import { getClientId } from '../../utils';
import ParentsRequest from '../../utils/parentsRequest';
import { KEY_PARENTS_API_TYPE_CHILD, SESSION_KEY_JWT } from '../../constants';
import { ErrorResponse } from '../../types';
import * as Sentry from "@sentry/react";

const registerChildren = async (userId: any, children: any) => {
    let arrayResponse = {
        success: false,
        message: 'Failed to add children.',
        data: null,
    };

    const clientId = getClientId();
    const jwtToken = localStorage.getItem(SESSION_KEY_JWT);

    try {
        const requestBody = {
            userId: userId,
            domain: clientId,
            children,
            type: KEY_PARENTS_API_TYPE_CHILD,
        };

        if (jwtToken) {
            const response = await ParentsRequest.post('/children/register', requestBody, jwtToken);

            if (response.status === 200) {
                arrayResponse.success = true;
                arrayResponse.message = 'Children added.';
                arrayResponse.data = response.data.data.children;
            }
        }

        return arrayResponse;
    } catch (error) {
        Sentry.captureException(error);
        const axiosError = error as AxiosError<ErrorResponse>;
        if (axiosError.response && axiosError.response.status === 400) {
            arrayResponse.message = axiosError.response.data.message;
        }
        return arrayResponse;
    }
}

export default registerChildren;
